
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"2","width":"20","height":"20","rx":"4","fill":"#D89464"}}),_c('path',{attrs:{"d":"M15.36 14.543c-.47 0-.89.185-1.21.476l-4.402-2.562a2.02 2.02 0 00.056-.432c0-.148-.025-.29-.056-.432L14.1 9.056a1.85 1.85 0 003.111-1.352 1.85 1.85 0 00-1.852-1.852 1.85 1.85 0 00-1.852 1.852c0 .148.025.29.056.432l-4.352 2.537A1.85 1.85 0 006.1 12.025a1.85 1.85 0 003.111 1.352l4.395 2.567c-.03.13-.05.266-.05.402 0 .994.81 1.802 1.803 1.802.994 0 1.803-.808 1.803-1.802s-.809-1.803-1.803-1.803z","fill":"#fff"}})])
          )
        }
      }
    